import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  AssignResidentToBuildingCommand,
  GetResidentsByBuildingIdCommand,
} from './permanence-building.commands';
import { AssignedResidentToBuildingEvent } from './permanence-building.events';
import {
  GottenResidentsByBuildingDomainEvent,
  GottenResidentsDomainEvent,
} from '../../resident/state-management/resident.events';

@Injectable()
export class PermanenceBuildingEffects {
  prefix = 'permanence-building';
  assignResidentToBuildingCommand: Observable<Action<string>> & CreateEffectMetadata;
  getResidentsByBuildingIdCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.assignResidentToBuildingCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      AssignResidentToBuildingCommand,
      AssignedResidentToBuildingEvent,
      this.prefix,
    );

    this.getResidentsByBuildingIdCommand = this.sciGuaduaHttpRequestHandler.handleEvent({
      command: GetResidentsByBuildingIdCommand,
      prefix: this.prefix,
      others: (httpResponse: any, commandData: any) => {
        if (httpResponse.meta?.code !== 'PermanenceBuilding:GottenResidentsDomainEvent') {
          return [];
        }
        const data = httpResponse.data;
        return [
          GottenResidentsByBuildingDomainEvent({
            buildingId: commandData.buildingId,
            residents: data,
          }),
        ];
      },
    });
  }
}
